var customerLevel = "free"; // free, basic or pro

//var stripe = Stripe('pk_test_oTBdaj3DiPoh2GN2LRP6bgzS');
var stripe = Stripe('pk_live_2xaQxOvCEelcE2SQvmCtWQac');

var elements = stripe.elements();

var userAccountRef = null;

function initializeStripe() {
    // Custom styling can be passed to options when creating an Element.
    var style = {
      base: {
        // Add your base input styles here. For example:
        fontSize: '20px',
        color: "#32325d",
      }
    };

    if (typeof elements === 'undefined') {
        console.log("unable to create Stripe Card in initializeStripe(). elements undefined")
        return;
    }
    // Create an instance of the card Element.
    var card = elements.create('card', {style: style});

    if (typeof card === 'undefined') {
        console.log("unable to create Stripe Card in initializeStripe(). card undefined")
        return;
    }

    // Add an instance of the card Element into the `card-element` <div>.
    card.mount('#card-element');

    card.addEventListener('change', function(event) {
        var displayError = document.getElementById('card-errors');
        if (event.error) {
            displayError.textContent = event.error.message;
        } else {
            displayError.textContent = '';
        }
    });

    // Create a token or display an error when the form is submitted.
    var form = document.getElementById('payment-form');
    form.addEventListener('click', function(event) {
        event.preventDefault();
        stripe.createToken(card).then(function(result) {
            if (result.error) {
                // Inform the customer that there was an error.
                var errorElement = document.getElementById('card-errors');
                errorElement.textContent = result.error.message;
                console.log(result.error.message);
            } else {
                // Send the token to your server.
                stripeTokenHandler(result.token);
                //console.log(result.token);
                // add purchase event here...
                gtag('event', 'conversion', {'send_to': 'AW-10885564398/imG-COK3xosZEO6P0sYo'});
            }
        });
    });
}

function stripeTokenHandler(token) {
  // Insert the token ID into the form so it gets submitted to the server

  $('#submit-payment-spinner').removeClass('d-none');
  $('#submit-payment-button').prop('disabled', true);

  var form = document.getElementById('payment-form');
  var hiddenInput = document.createElement('input');
  hiddenInput.setAttribute('type', 'hidden');
  hiddenInput.setAttribute('name', 'stripeToken');
  hiddenInput.setAttribute('value', token.id);
  form.appendChild(hiddenInput);

  var user = firebase.auth().currentUser;
  var uid = user.uid;
  var email = user.email;
  var tok = token.id;
  var card = token.card.id;

  var dict = {uid: uid, email: email, token: tok, card: card};

  firebase.auth().currentUser.getIdToken().then(function(token) {
      $.ajax({
          url:'https://us-central1-webstructrual.cloudfunctions.net/subscription',
          type:'POST',
          data:JSON.stringify(dict),
          contentType:"application/json; charset=utf-8",
          dataType:"json",
          headers: { "Authorization": "Bearer " + token },
          success: function(data){
              $('#submit-payment-button').prop('disabled', false);
              $('#submit-payment-spinner').addClass('d-none');
              $("#subscribe-response-error").addClass('d-none');
              $("#subscribe-response-error").html("");
              var user = firebase.auth().currentUser;
              onLoginSuccess(user);
          },
          error: function (xhr, ajaxOptions, thrownError) {
              $('#submit-payment-button').prop('disabled', false);
              $('#submit-payment-spinner').addClass('d-none');
              $("#subscribe-response-error").removeClass('d-none');
              $("#subscribe-response-error").html(xhr.responseText);
          }
      });
  });
}

function initializeFirebaseAuth() {

    firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)

    firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
            document.dispatchEvent(new CustomEvent('customer-logged-in', {detail: user}))
            onLoginSuccess(user);
            checkStripeSubscription();
        } else {
            document.dispatchEvent(new CustomEvent('customer-logged-out'))
            onLogoutSuccess();
        }
    });
}

function openSignupModal() {
    $('#modal-sign-up-error').addClass('d-none');
    $('#modal-sign-up-form').modal('show');
}

function openSigninModal() {
    $('#modal-sign-in-error').addClass('d-none');
    $('#modal-login-form').modal('show');
}

function openForgotPasswordModal() {
    $('#modal-forgot-password-form').modal('show');
}

function openFinishUpgradeModal() {
    $('#modal-finish-upgrade').modal('show');
}

function login() {
    var email = $('#sign-in-email').val().trim();
    var password = $('#sign-in-password').val().trim();

    document.getElementById('login-wait-spinner').classList.remove('d-none')

    // firebase login...
    firebase.auth().signInWithEmailAndPassword(email, password)
    .then(function(response) {
        onLoginSuccess(response.user);
    })
    .catch(function(error) {
        // Handle Errors here.
        const errorCode = error.code
        const errorMessage = error.message
        let str = errorMessage
        if(errorCode === 'auth/wrong-password') {
            str = 'Invalid password.'
        }
        document.getElementById('modal-sign-in-error').classList.remove('d-none')
        document.getElementById('modal-sign-in-error').innerHTML = str
        document.getElementById('login-wait-spinner').classList.add('d-none')
    })
}

function logout() {
    firebase.auth().signOut().then(function() {
        onLogoutSuccess();
    }).catch(function(error) {
        // An error happened.
        console.error(error)
    })
}

function signup() {
    var firstLast = $('#sign-up-first-last').val().trim();
    var email = $('#sign-up-email').val().trim();
    var password = $('#sign-up-password').val().trim();

    $('#sign-up-wait-spinner').removeClass('d-none');

    firebase.auth().createUserWithEmailAndPassword(email, password).then(function(user) {
        var user = firebase.auth().currentUser;
        createUser(user, firstLast);
        $('#sign-up-wait-spinner').addClass('d-none');
        return
    }, function(error) {
        var errorCode = error.code;
        var errorMessage = error.message;
        $('#modal-sign-up-error').removeClass('d-none');
        $('#modal-sign-up-error').html(errorMessage);
        $('#sign-up-wait-spinner').addClass('d-none');
    }).then(function() {
    });
}

function sendForgotPasswordEmail() {
    $('#forgot-password-wait-spinner').removeClass('d-none');
    var email = $('#forgot-password-email').val().trim();
    firebase.auth().sendPasswordResetEmail(email).then(function() {
        // Email sent.
        $('#forgot-password-wait-spinner').addClass('d-none');
        $('#modal-forgot-password-form').modal('hide');
        $('#modal-forgot-password-email-sent').modal('show');
        // show toast "A reset link has been emailed"
    }).catch(function(error) {
        // An error happened.
        var errorCode = error.code;
        var errorMessage = error.message;
        $('#forgot-password-wait-spinner').addClass('d-none');
        $('#modal-forgot-password-error').html(errorMessage);
    });
}

function resendVerifyEmailLink() {
    var user = firebase.auth().currentUser;

    user.sendEmailVerification().then(function() {
        // Email sent.
        $('#modal-verify-email').modal('hide');
        $('#modal-verify-email-sent').modal('show');
    }).catch(function(error) {
        // An error happened.
        alert('Verification email could not be sent. Please try again later.');
    });
}

function createUser(user, name) {
    firebase.auth().currentUser.sendEmailVerification().then(function() {
        // Email sent.
    }, function(error) {
        console.error(error)
    });

    // make a user entry in the database
    firebase.database().ref('users/' + user.uid).set({
        username: name
    })
    .then(function(docRef) {
        $('#modal-sign-up-form').modal('hide');
    })
    .catch(function(error) {
        console.error("Error adding document: ", error);
    });
}

function onLoginSuccess(user) {

    gtag('set', {'userId': user.uid})
-   gtag('event', 'login')

    $('#modal-login-form').modal('hide');
    $('#modal-sign-up-form').modal('hide');
    $('#modal-finish-upgrade').modal('hide');
    
    document.getElementById('modal-sign-up-error').classList.add('d-none')
    document.getElementById('modal-sign-in-error').classList.add('d-none')
    document.getElementById('login-wait-spinner').classList.add('d-none')
    
    configureLoggedIn()

    checkStripeSubscription()
}

function checkStripeSubscription() {
    firebase.auth().currentUser.getIdToken().then(function(token) {
        fetch('https://us-central1-webstructrual.cloudfunctions.net/checkSubscription', {
            method: 'POST', 
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            headers: {
              'Content-Type': 'application/json; charset=utf-8',
              'Authorization': `Bearer ${token}`
            },
          }).then((response) => {
            if(response.ok) {
                configureIsUpgraded()
                document.dispatchEvent(new CustomEvent('customer-logged-in-and-upgraded'))
            } else {
                response.text().then(text => {
                    if(text === 'Subscription is: past_due') {
                        configureRecurringPaymentFailed()
                        document.dispatchEvent(new CustomEvent('recurring-payment-failed'))
                    } else if(text === "Subscription is: canceled") {
                        configureSubscriptionPreviouslyCanceled()
                        document.dispatchEvent(new CustomEvent('subscription-previously-canceled'))
                    } else {
                        configureNeedsUpgrade()
                        document.dispatchEvent(new CustomEvent('customer-logged-in-not-upgraded'))
                    }
                }) 
            }
          }).catch( (error) => {
            console.error(error)
            // error -> assume not subscribed
            configureNeedsUpgrade()
            document.dispatchEvent(new CustomEvent('customer-logged-in-not-upgraded'))
          })
    })
}

function redirectToCustomerPortal() {
    // show wait cursor
    firebase.auth().currentUser.getIdToken().then(function(token) {
        document.getElementById("payment-failed-row-error").classList.add("d-none")
        document.getElementById("resubscribe-row-error").classList.add("d-none")
        
      fetch('https://us-central1-webstructrual.cloudfunctions.net/customerPortal', {
        method: 'POST', 
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        },
      }).then((response) => {
        if(response.ok) {
          response.text().then((urlStr) => {
            window.location.replace(urlStr)
          })
        } else {
          document.getElementById("payment-failed-row-error").classList.remove("d-none")
          document.getElementById("resubscribe-row-error").classList.remove("d-none")
        }
      })
      .catch( (error) => {
        console.error(error)
        document.getElementById("payment-failed-row-error").classList.remove("d-none")
        document.getElementById("resubscribe-row-error").classList.remove("d-none")
      })
    })
  }

function onLogoutSuccess() {
    customerLevel = "free"
    configureLoggedOut()
    document.dispatchEvent(new CustomEvent('on-logout-success'))
}

function enablePrinting() {
    document.getElementById('design-summary-div').classList.remove('hidden-print')
    document.getElementById('beam-reactions-table').classList.remove('hidden-print');
    document.getElementById('plots-div').classList.remove('hidden-print');
    document.getElementById('numerical-results-div').classList.remove('hidden-print');
    document.getElementById('results-view-div').classList.remove('hidden-print');
    document.getElementById('footer').classList.add('hidden-print');
}

function disablePrinting() {
    document.getElementById('design-summary-div').classList.add('hidden-print')
    document.getElementById('beam-reactions-table').classList.add('hidden-print');
    document.getElementById('plots-div').classList.add('hidden-print');
    document.getElementById('numerical-results-div').classList.add('hidden-print');
    document.getElementById('results-view-div').classList.add('hidden-print');
    document.getElementById('footer').classList.remove('hidden-print');
}

function configureLoggedIn() {

    customerLevel = 'basic'

    disablePrinting()

    // hide payment failed and resubscribe info boxes
    document.getElementById('payment-failed-row-error').classList.add('d-none')
    document.getElementById('payment-failed-row').classList.add("d-none")
    document.getElementById('resubscribe-row-error').classList.add('d-none')
    document.getElementById('resubscribe-row').classList.add("d-none")

    // check company name
    firebase.database().ref('/users/' + firebase.auth().currentUser.uid).once('value').then(function(snapshot) {
        if(snapshot.val().companyName) {
            companyName = snapshot.val().companyName;
            document.getElementById("your-company-name").innerHTML = companyName
        }
    })
}

function configureIsUpgraded() {

    customerLevel = 'pro'

    // show project list
    document.getElementById('project-list').classList.remove('d-none')
    
    // hide upgrade CTAs
    document.getElementById('upgrade-list-item').classList.add('d-none')
    document.getElementById('upgrade-now-row').classList.add('d-none')
    document.getElementById('finish-upgrade-list-item').classList.add('d-none')
    document.getElementById('upgrade-info').classList.add('d-none')

    // load projects
    getProjectsFromDatabaseAndUpdateProjectList()

    enablePrinting()
}

function configureNeedsUpgrade() {

    // hide project list
    document.getElementById('project-list').classList.add('d-none')

    // update brand version badge
    document.getElementById('brand-version-badge').innerHTML = 'Basic'
    
    // hide the button that starts the sign up process
    document.getElementById('upgrade-list-item').classList.add('d-none')

    // show the button that says upgrade now
    document.getElementById('upgrade-now-row').classList.remove('d-none')

    // finish upgrade list iteem
    document.getElementById('finish-upgrade-list-item').classList.remove('d-none')

    // hide this one too, it starts the sign up process
    document.getElementById('upgrade-info').classList.add('d-none')

    // hide the project list group - we only want to show the "finish upgrade" list item
    document.getElementById('project-list-group').classList.add('d-none')

    $('#modal-finish-upgrade').modal('show');

    disablePrinting()
    
}

function configureRecurringPaymentFailed() {
    // hide all upgrade CTAs - customer should use the stripe portal
    document.getElementById('upgrade-now-row').classList.add('d-none')
    document.getElementById('finish-upgrade-list-item').classList.add('d-none')
    document.getElementById('upgrade-info').classList.add('d-none')

    // hide the button that starts the sign up process
    document.getElementById('upgrade-list-item').classList.add('d-none')

    document.getElementById('payment-failed-row-error').classList.add('d-none')
    document.getElementById('payment-failed-row').classList.remove('d-none')

    disablePrinting()
}

function configureSubscriptionPreviouslyCanceled() {
    
    configureNeedsUpgrade()

    document.getElementById('upgrade-now-row').classList.add('d-none')

    document.getElementById('resubscribe-row-error').classList.add('d-none')
    document.getElementById('resubscribe-row').classList.remove('d-none')

    disablePrinting()
}

function configureLoggedOut() {
    $('#upgrade-list-item').removeClass('d-none');
    $('#project-list').addClass('d-none');
    $('#upgrade-now-row').addClass('d-none');
    $('#finish-upgrade-list-item').addClass('d-none');
    $('#project-list-group').addClass('d-none');
    $("#upgrade-info").removeClass('d-none');
    document.getElementById('payment-failed-row-error').classList.add('d-none')
    document.getElementById('payment-failed-row').classList.add("d-none")
    document.getElementById('resubscribe-row-error').classList.add('d-none')
    document.getElementById('resubscribe-row').classList.add("d-none")
    disablePrinting()
}
